import dayjs from "dayjs";
import _ from "underscore";

import { ServiceMenuEventInterface } from "@/interfaces/service-menu-event.interface";

/**
 * イベント用ユーティリティ
 */
export class EventUtil {
  /**
   * 年を取得する
   */
  public static getYear(str: string): string {
    // 日付のみの文字列は、
    // OSのタイムゾーン設定によらず同じ日付を表示するために、
    // Asia/Tokyoのタイムゾーンの日付として読み込み、
    // Asia/Tokyoのタイムゾーンとして出力する。
    return dayjs.tz(str, "Asia/Tokyo").format("YYYY");
  }

  /**
   * イベントを並べ替える
   */
  public static sort(
    events: ServiceMenuEventInterface[]
  ): ServiceMenuEventInterface[] {
    events = _.sortBy(
      events,
      (event: ServiceMenuEventInterface) =>
        EventUtil.getTime(event.eventDate) +
        EventUtil.getTime(event.lastUpdatedAt)
    );
    events.reverse();

    return events;
  }

  /**
   * 日付けを取得する
   */
  private static getTime(str: string): string {
    return dayjs(str).format("YYYYMMDDHHmmss");
  }
}
